import { Injectable } from '@angular/core';
import { ExceptionCategory } from '../enums/exception-category';
import { ExceptionSeverity } from '../enums/exception-severity';
import { ExceptionType } from '../enums/exception-type';
import { DataExchangeService } from '../services/session/data-exchange.service';

@Injectable({ providedIn: 'root' })
export class ExceptionEvent {
  type?: ExceptionType;
  category?: ExceptionCategory;
  severity?: ExceptionSeverity;
  status: string = 'OPEN';
  module: string = 'walletron-pages-ui';
  brandCode: string;
  source?: string;
  exceptionCode?: string;
  exceptionMessage?: string;

  constructor(private dataExchangeService: DataExchangeService) {
    this.brandCode = this.dataExchangeService.getBrandCode();
  }

  initialize(
      source: string, 
      exceptionCode: string, 
      exceptionMessage: string,
      type: string = 'OTHER', 
      category: string = 'CUSTOMER_ACCOUNT_FAILURE', 
      severity: string = 'LOW'
    ): void {
    this.source = source;
    this.exceptionCode = exceptionCode;
    this.exceptionMessage = exceptionMessage;
    this.type = ExceptionType[type as keyof typeof ExceptionType];
    this.category = ExceptionCategory[category as keyof typeof ExceptionCategory];
    this.severity = ExceptionSeverity[severity as keyof typeof ExceptionSeverity];
  }

  // setType(type: ExceptionType): void {
  //   this.type = type;
  // }

  // setCategory(category: ExceptionCategory): void {
  //   this.category = category;
  // }

  // setSeverity(severity: ExceptionSeverity): void {
  //   this.severity = severity;
  // }

  toJson(): string {
    return JSON.stringify({
      type: this.type,
      category: this.category,
      severity: this.severity,
      status: this.status,
      brandCode: this.brandCode,
      module: this.module,
      source: this.source,
      exceptionCode: this.exceptionCode,
      exceptionMessage: this.exceptionMessage,
    });
  }
}
